import { post } from "../../../../http";
import { SubscriptionItemType } from "../../../types";
import { subscriptionsBaseApiUrl } from "../../subscriptionsBaseUrl";

import { subscriptionItemToDraftDTO } from "../../utils";
import { AddSubscriptionMutationRequest } from "./addSubscription.types";

export const addSubscription = async (itemDraft: AddSubscriptionMutationRequest) => {
  const itemDraftDTO = subscriptionItemToDraftDTO(itemDraft);

  if (itemDraftDTO.subscriptionType === SubscriptionItemType.Slide) {
    await post(`${subscriptionsBaseApiUrl}/ReportsSubscription`, itemDraftDTO);
  } else if (itemDraftDTO.subscriptionType === SubscriptionItemType.BulkExport) {
    await post(`${subscriptionsBaseApiUrl}/BulkExportSubscription`, itemDraftDTO);
  } else if (itemDraftDTO.subscriptionType === SubscriptionItemType.SavedBulkExport){
    await post(`${subscriptionsBaseApiUrl}/SavedBulkExportSubscription`, itemDraftDTO);
  }
};
